// eslint-disable-next-line
export const TABS = [
  { heading: 'Contract line', tabKey: 'lineTabData' },
  { heading: 'Contract line detail', tabKey: 'lineDetailTabData' },
  { heading: 'Minimum requirements', tabKey: 'MinReq' },
  { heading: 'Optional equipment', tabKey: 'OptEq' },
  { heading: 'Engine and fuel', tabKey: 'Engine' },
  { heading: 'Colors', tabKey: 'colorTabData' },
  { heading: 'Documentation', tabKey: 'Documentation' }, // saved separately
];
